import { Grid } from "@material-ui/core";
import React, { Component } from "react";
import { Typography } from "@mui/material";
import { getBaseFileInfo } from "../../actions/backend/file";

export default class PdfViewer extends Component {
  state = {
    static_url: "static/pdfjs/web/viewer.html?file=",
    file_url: "",
    file_name: "",
  };

  componentDidMount() {
    let data = { dfs_url: localStorage.getItem("file_url") };
    this.setState({
      file_url: localStorage.getItem("file_url"),
    });
    getBaseFileInfo(data).then((res) => {
      this.setState({
        file_name: res.results[0].file_name,
      });
    });
    localStorage.removeItem("file_url");
  }

  render() {
    return (
      <Grid>
        <Typography>{"文件名称：" + this.state.file_name}</Typography>
        <iframe
          src={this.state.static_url + this.state.file_url}
          title="preview"
          frameborder="0"
          height="1280px"
          width="100%"
        ></iframe>
      </Grid>
    );
  }
}
